import { render } from "./FaceQRReloadSection.vue?vue&type=template&id=b5730250&scoped=true"
import script from "./FaceQRReloadSection.vue?vue&type=script&lang=js"
export * from "./FaceQRReloadSection.vue?vue&type=script&lang=js"

import "./FaceQRReloadSection.vue?vue&type=style&index=0&id=b5730250&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5730250"

export default script